import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';

import AccordionSummary from '@material-ui/core/AccordionSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

interface Props {
  children: React.ReactNode;
}

function AccordionSectionHeader({ children }: Props) {
  const classes = useStyles();

  return (
    <AccordionSummary expandIcon={<ExpandMoreIcon />} className={classes.accordionSummary}>
      {children}
    </AccordionSummary>
  );
}

const useStyles = makeStyles(theme => ({
  root: {},
  accordionSummary: {
    alignItems: 'center',
    padding: 0,
    margin: 0,
    '& .MuiAccordionSummary-content': {
      margin: 0,
    },
    '& .MuiAccordionSummary-expandIcon': {
      marginRight: theme.spacing(0.5),
    },
  },
}));

export default AccordionSectionHeader;
